import * as widgetActions from "@app/widgets/widgets/statistics-sold-objects-widget/ngrx/statistics-sold-objects-widget.actions";
import {
  Action,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from "@ngrx/store";
import { WidgetsModuleState } from "@app/widgets/widgets-module.reducer";

export interface SoldObjectsState {
  stats: number;
  previousStats: number;
  loading: boolean;
}

export const initialState: SoldObjectsState = {
  loading: false,
  stats: null,
  previousStats: null,
};

export function soldObjectsReducer(
  state: SoldObjectsState,
  action: Action
): SoldObjectsState {
  return reducer(state, action);
}

const reducer = createReducer(
  initialState,
  on(
    widgetActions.fetchStatisticsRequest,
    widgetActions.fetchPreviousStatisticsRequest,
    (state) => ({
      ...state,
      loading: true,
    })
  ),
  on(widgetActions.fetchStatisticsSuccess, (state, { stats }) => ({
    ...state,
    loading: false,
    stats,
  })),
  on(
    widgetActions.fetchPreviousStatisticsSuccess,
    (state, { previousStats }) => ({
      ...state,
      loading: false,
      previousStats,
    })
  ),
  on(
    widgetActions.fetchStatisticsFail,
    widgetActions.fetchPreviousStatisticsFail,
    (state) => ({
      ...state,
      loading: false,
    })
  )
);

const selectFeature = createFeatureSelector<WidgetsModuleState>("widgets");
const getState = createSelector(
  selectFeature,
  (state: WidgetsModuleState) => state.soldObjects
);

export const getStats = createSelector(
  getState,
  (state: SoldObjectsState) => state.stats
);

export const getDifference = createSelector(
  getState,
  (state: SoldObjectsState) => state.stats - state.previousStats
);

export const getLoading = createSelector(
  getState,
  (state: SoldObjectsState) => state.loading
);
